const siegeBattles = `

Every town on Arcane will be **sieged by three different mobs**. Each town has **four spawn points** with **one Leader and three Guards**. Additionally, some weaker enemies are spread around the town to create a full siege scenario.

---

### The Level Cap of the Towns
To ensure fair participation, there are **level caps** per town:
- **Horizon**: max. Level **119**
- **Katan**: max. Level **149**
- **Laksy and Rondo**: max. Level **169**
- **City of Ruins**: **Unlimited**

⚠️ If a **high-level player** kills a lower-level siege mob, it will **respawn**, and the player will be **teleported** to the town's teleporter. The player will receive a **notification** recommending a more suitable siege location for their level.

---

### Rewards for Defending
Successfully defending a town grants **specific buffs**:
- **Horizon**: Luck +50
- **Katan**: Vampiric Rage (**absorbs 3% of damage as HP**)
- **Laksy**: Max. HP +35%
- **Rondo**: Max. MP +35%
- **City of Ruins**: Crit. Power +90
- **All defended**: Aura of Halisha +200 on everything, +50 Luck

⏳ **Buff Duration**: Each buff lasts for **two hours**. If all towns are defended, all buffs are **refreshed to two hours**.`;

export default siegeBattles;
